import { Row, Col } from 'antd'

import _map from 'lodash/map'

import Image from 'components/Image'
import Paragraph from 'components/Paragraph'
import Icon from 'components/Icon'
import Link from 'components/Link'

import { global } from 'constant/data'

import Styled from './styled'

const logoImage = '/assets/images/logo-white.svg'

const RenderMenu = ({ menus }) => {
  return (
    <ul className="menu-ul">
      {_map(menus, (item, index) => {
        const name = item?.name
        const icon = item?.icon
        const link = item?.link
        const openNewTab = item?.openNewTab || false
        return (
          <li className="menu-li" key={index}>
            {icon && <div className="icon-menu-block">{icon}</div>}
            <Link href={link} openNewTab={openNewTab}>
              <Paragraph>{name}</Paragraph>
            </Link>
          </li>
        )
      })}
    </ul>
  )
}

export default function Footer() {
  const address = global.addressOffice
  const phoneOffice = global.phoneOffice
  const copyrightText = global.copyright

  const contactMenus = [
    {
      name: phoneOffice,
      icon: <Icon.Phone className="icon-menu icon-phone" />,
      link: `tel:${phoneOffice}`,
    },
    {
      name: 'support@24slg.com',
      icon: <Icon.Envelope className="icon-menu" />,
      link: 'mailto:support@24slg.com',
    },
  ]

  const channels = [
    { name: 'Facebook', icon: <Icon.Facebook />, link: 'https://bit.ly/3axwz6s' },
    { name: 'LINE', icon: <Icon.Line />, link: 'https://bit.ly/3a5kdCi' },
    { name: 'Instagram', icon: <Icon.Instragram />, link: 'https://bit.ly/3NJ38wr' },
    { name: 'TikTok', icon: <Icon.Tiktok />, link: 'https://bit.ly/3t7dK0a' },
    { name: 'YouTube', icon: <Icon.Youtube />, link: 'https://bit.ly/3N3ENSd' },
  ]

  const companyMenus = [
    { name: 'โปรโมชั่น', icon: null, link: '/voucher' },
    { name: 'บทความ', icon: null, link: '/blog', openNewTab: true },
    { name: 'บริการภาคธุรกิจ', icon: null, link: 'https://business.24x.co.th/th', openNewTab: true },
    {
      name: 'ร่วมงานกับเรา',
      icon: null,
      link: 'https://24slg.bamboohr.com/jobs',
      openNewTab: true,
    },
  ]

  const helpMenus = [
    { name: 'คำถามที่พบบ่อย', icon: null, link: '/faq' },
    { name: 'นโยบายความเป็นส่วนตัว', icon: null, link: '/legal' },
    { name: 'ข้อกำหนดและเงื่อนไข', icon: null, link: '/terms-and-conditions' },
  ]

  return (
    <Styled className="footer-component">
      <footer>
        <div className="container">
          <div className="block1">
            <div className="left-block">
              <Image src={logoImage} alt="24 FIX" className="logo-image" />
              <div className="address-block">
                <Paragraph>บริษัท ทเวนตี้โฟร์ โซลูชั่น กรุ๊ป (ประเทศไทย) จำกัด</Paragraph>
                <Paragraph>{address}</Paragraph>
              </div>
            </div>

            <div className="right-block">
              <Row gutter={[20, 15]} className="menus-container">
                <Col span={12} md={8} lg={5} className="menu-block">
                  <Paragraph className="font-semibold">ช่องทางการติดต่อ</Paragraph>
                  <RenderMenu menus={contactMenus} />
                </Col>
                <Col span={12} md={8} lg={5} className="menu-block">
                  <Paragraph className="font-semibold">ช่องทางการติดตาม</Paragraph>
                  <div className="channel-block">
                    {_map(channels, (channel, index) => {
                      return (
                        <Link
                          href={channel?.link}
                          openNewTab
                          key={index}
                          className="icon-channel"
                          aria-label={channel?.name}
                        >
                          {channel?.icon}
                        </Link>
                      )
                    })}
                  </div>
                </Col>
                <Col span={12} md={8} lg={5} className="menu-block">
                  <RenderMenu menus={companyMenus} />
                </Col>
                <Col span={12} md={8} lg={5} className="menu-block">
                  <RenderMenu menus={helpMenus} />
                </Col>
              </Row>
            </div>
          </div>

          <div className="copy-right copy-right-desktop">
            <Paragraph>{copyrightText}</Paragraph>
          </div>

          <div className="copy-right copy-right-mobile">
            <Paragraph>{copyrightText}</Paragraph>
          </div>
        </div>
      </footer>
    </Styled>
  )
}
